import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from "prop-types";


class NewsArticleSummary extends Component {
  static propTypes = {
    title: PropTypes.string,
    dateString: PropTypes.string,
    to: PropTypes.string,
    excerpt: PropTypes.string,
  };
  static defaultProps = {
    title: "title",
    dateString: "dateString",
    to: "/",
    excerpt: "excerpt",
  };
  render() {
    const {title, dateString, to, excerpt} = this.props
    return (
      <Fragment>
        <div className="article-title">{title}</div>
        <div className="article-date">{dateString}</div>
        <div className="article-desc">{excerpt}</div>
        <Link to={to} className="read-more">Read more ></Link>
      </Fragment>
    );
  }
}

export default NewsArticleSummary;


// WEBPACK FOOTER //
// ./src/components/NewsArticleSummary.js